module.exports = __webpack_public_path__ + "static/media/gg.c447047f.svg";